import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetCardPaymentSum = IAction<EPaymentActions.SET_CARD_SUM, number>

const setCardPaymentSum = (sum: number): TSetCardPaymentSum => ({
    type: EPaymentActions.SET_CARD_SUM,
    payload: sum,
});

export default setCardPaymentSum;
